import React, {useState} from 'react'
import './Navbar.css'

const Navbar = () => {

    const [click, setclick] = useState(false);
    const handelClick = () => setclick(!click);

  return (
    <>
        <nav className={click ? "show" : ""} onClick={handelClick}>
            <a href='#home'>Home</a>
            <a href='#projects'>Projects</a>
            <a href='#skills'>Skills</a>
            <a href='#about'>About</a>
            <a href='#contact'>Contact</a>
            <img className='close' src='./assets/close.svg' alt='' />
        </nav>
        <div className='menu'>
            <img src='./assets/menu.svg' alt='' onClick={handelClick}/>
        </div>
        
    </>
  )
}

export default Navbar